"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.split");

require("core-js/modules/web.dom.iterable");

var _toConsumableArray2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));

require("core-js/modules/es6.array.find-index");

require("core-js/modules/es6.array.find");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

var _defineProperty2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuePropertyDecorator = require("vue-property-decorator");

var _loading = require("@/mixins/loading/loading");

var _milkRun = require("@/mixins/milk-run/milk-run");

var _elementUi = require("element-ui");

var _orderTableColumnSelector = _interopRequireDefault(require("@/views/milk-run/components/order-table-column-selector/order-table-column-selector.vue"));

var _fullscreen = _interopRequireDefault(require("@/components/fullscreen/fullscreen.vue"));

var _moment = _interopRequireDefault(require("moment"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var PAGE_SIZE_KEY = 'pageSize';

var MROrderTableComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(MROrderTableComponent, _Mixins);

  var _super = _createSuper(MROrderTableComponent);

  function MROrderTableComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, MROrderTableComponent);
    _this = _super.apply(this, arguments);
    _this.moment = _moment.default;
    _this.buffer = {};
    _this.selectedColumns = [];
    return _this;
  }

  (0, _createClass2.default)(MROrderTableComponent, [{
    key: "onPageSizeChanges",
    value: function onPageSizeChanges(newVal) {
      window.localStorage.setItem(PAGE_SIZE_KEY, newVal);
    }
  }, {
    key: "onUnassignedOrdersChanges",
    value: function onUnassignedOrdersChanges() {
      var _this2 = this;

      this.$nextTick(function () {
        var ordersIntersection = _this2.helper.intersectionBy(_this2.$unassignedOrders, _this2.$selectedOrders, 'id');

        _this2.toggleRowsSelection(ordersIntersection);
      });
    }
  }, {
    key: "$currentPage",
    get: function get() {
      return this.$store.getters['milkRun/pagination']['currentPage'];
    }
  }, {
    key: "$totalData",
    get: function get() {
      return this.$store.getters['milkRun/pagination']['totalData'];
    }
  }, {
    key: "$pageSize",
    get: function get() {
      return this.$store.getters['milkRun/pagination']['pageSize'];
    }
  }, {
    key: "created",
    value: function created() {}
  }, {
    key: "mounted",
    value: function mounted() {
      var pageSize = window.localStorage.getItem(PAGE_SIZE_KEY);

      if (!this.helper.isUndefined(pageSize)) {
        var p = _objectSpread({}, this.$pagination);

        p.pageSize = parseInt(pageSize, 10);
        this.$setPagination(p);
      }
    }
  }, {
    key: "handlePagination",
    value: function () {
      var _handlePagination = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(val, type) {
        var p;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                p = _objectSpread({}, this.$pagination);

                if (type === 'sizeChange') {
                  p.currentPage = 1;
                  p.pageSize = val;
                }

                if (type === 'currentChange') {
                  p.currentPage = val;
                }

                this.$setPagination(p);
                _context.next = 6;
                return this.$getUnassignedOrders();

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handlePagination(_x, _x2) {
        return _handlePagination.apply(this, arguments);
      }

      return handlePagination;
    }()
  }, {
    key: "tableRowClassName",
    value: function tableRowClassName(_ref) {
      var row = _ref.row;
      var errorBool = this.isInvalidOrder(row);
      var selectedBool = false;

      if (this.helper.find(this.$selectedOrders, {
        shipmentReference: row.shipmentReference
      })) {
        selectedBool = true;
      } // Socket for global orders


      if (this.isOrderIdExistInGlobal(row.id)) {
        return 'used-row';
      }

      return !errorBool ? selectedBool ? 'success-row cursor-pointer' : 'cursor-pointer' : selectedBool ? 'error-row' : 'warning-row';
    }
  }, {
    key: "handleSort",
    value: function () {
      var _handleSort = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref2) {
        var column, prop, order, p;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                column = _ref2.column, prop = _ref2.prop, order = _ref2.order;

                if (!(prop !== null && prop !== undefined)) {
                  _context2.next = 9;
                  break;
                }

                p = _objectSpread({}, this.$pagination);

                if (order === 'ascending') {
                  p.order = 'ASC';
                }

                if (order === 'descending') {
                  p.order = 'DESC';
                }

                p.orderBy = prop;
                this.$setPagination(p);
                _context2.next = 9;
                return this.$getUnassignedOrders();

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleSort(_x3) {
        return _handleSort.apply(this, arguments);
      }

      return handleSort;
    }()
  }, {
    key: "isRowSelectable",
    value: function isRowSelectable(row, index) {
      return !this.isInvalidOrder(row) && !this.isOrderIdExistInGlobal(row.id);
    }
  }, {
    key: "selectClickHandler",
    value: function selectClickHandler($event, row) {
      // Socket for global orders

      /*this.socketAPI.updateLMDGlobalSelectedOrders({
        user: this.$userInformation.user.name,
        orderId: [row.id],
        dataType: this.helper.findIndex(this.$selectedOrders, o => o['id'] === row['id']) === -1 ? 'add' : 'remove'
      });*/
      this.$selectedOrders = this.helper.findIndex(this.$selectedOrders, function (o) {
        return o['id'] === row['id'];
      }) === -1 ? this.helper.uniqBy([].concat((0, _toConsumableArray2.default)(this.$selectedOrders), [row]), 'id') : this.helper.filter(this.$selectedOrders, function (o) {
        return o['id'] !== row['id'];
      });
    }
  }, {
    key: "selectAllHandler",
    value: function selectAllHandler($event) {
      var currentPage = this.$currentPage;
      var prevBuffer = this.helper.cloneDeep(this.buffer[currentPage]);

      if ($event.length > 0) {
        this.buffer[currentPage] = this.helper.cloneDeep($event);
        this.$selectedOrders = this.helper.uniqBy([].concat((0, _toConsumableArray2.default)(this.$selectedOrders), (0, _toConsumableArray2.default)($event)), 'id');
      } else {
        this.$selectedOrders = this.helper.differenceBy(this.$selectedOrders, this.buffer[currentPage], 'id');
        this.buffer[currentPage] = this.helper.cloneDeep($event);
      } // Socket for global orders

      /*this.socketAPI.updateLMDGlobalSelectedOrders({
        user: this.$userInformation.user.name,
        orderId: $event.length > 0 ? this.buffer[currentPage].map(o => o['id']) : prevBuffer.map(o => o['id']),
        dataType: $event.length > 0 ? 'add' : 'remove'
      });*/

    }
  }, {
    key: "rowClickHandler",
    value: function rowClickHandler(row, column, $event) {
      if (this.isInvalidOrder(row) || this.isOrderIdExistInGlobal(row.id)) {
        return false;
      }

      var orderTable = this.helper.get(this.$refs, 'unassignedOrderTable', null); // Socket for global orders

      /*this.socketAPI.updateLMDGlobalSelectedOrders({
        user: this.$userInformation.user.name,
        orderId: [row.id],
        dataType: this.helper.findIndex(this.$selectedOrders, o => o['id'] === row['id']) === -1 ? 'add' : 'remove'
      });*/

      this.$selectedOrders = this.helper.findIndex(this.$selectedOrders, function (o) {
        return o['id'] === row['id'];
      }) === -1 ? this.helper.uniqBy([].concat((0, _toConsumableArray2.default)(this.$selectedOrders), [row]), 'id') : this.helper.filter(this.$selectedOrders, function (o) {
        return o['id'] !== row['id'];
      });
      orderTable.toggleRowSelection(row);
    }
  }, {
    key: "isSortable",
    value: function isSortable(colName) {
      return colName !== 'actionDateTime' && colName !== 'actionDistrict' && colName !== 'actionBuilding' && colName !== 'actionCompName' && colName !== 'actionPhoneNumber';
    }
  }, {
    key: "toggleRowsSelection",
    value: function toggleRowsSelection(rows) {
      var orderTable = this.helper.get(this.$refs, 'unassignedOrderTable', null);

      var p = _objectSpread({}, this.$pagination);

      rows ? rows.forEach(function (row) {
        orderTable.toggleRowSelection(row);
      }) : orderTable.clearSelection();
      this.$setPagination(p);
    }
  }, {
    key: "showFailedOrders",
    value: function showFailedOrders() {
      this.$emit('onFailedOrders', {
        isShowFailedOrders: true,
        failedOrders: this.$failedOrders
      });
    }
  }, {
    key: "toggleOrderFullscreen",
    value: function toggleOrderFullscreen() {
      var el = this.helper.get(this.$refs, 'fullscreen', null);

      if (el) {
        el.toggleFullscreen(true);
      }
    }
  }, {
    key: "formatItemInfo",
    value: function formatItemInfo(itemInfo) {
      if (this.helper.isUndefined(itemInfo)) {
        return [];
      }

      return itemInfo.split(/\r?\n/);
    }
  }, {
    key: "isGenericStringColumns",
    value: function isGenericStringColumns(code) {
      return code === 'zone' || code === 'projectCode' || code === 'customerCode' || code === 'shipmentReference' || code === 'commodityType' || code === 'serviceType' || code === 'remarks';
    }
  }, {
    key: "isGenericNumberColumns",
    value: function isGenericNumberColumns(code) {
      return code === 'weight' || code === 'volume' || code === 'cartons' || code === 'pallets' || code === 'quantity';
    }
  }, {
    key: "isGenericWaypointColumns",
    value: function isGenericWaypointColumns(code) {
      var waypointType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'P';
      return waypointType === 'P' && (code === 'pickDateTime' || code === 'pickDistrict' || code === 'pickBuilding' || code === 'pickCompName' || code === 'pickPhoneNumber') || waypointType === 'D' && (code === 'dropDateTime' || code === 'dropDistrict' || code === 'dropBuilding' || code === 'dropCompName' || code === 'dropPhoneNumber') || waypointType === 'T' && (code === 'actionDateTime' || code === 'actionDistrict' || code === 'actionBuilding' || code === 'actionCompName' || code === 'actionPhoneNumber');
    }
  }, {
    key: "isShowTableTooltip",
    value: function isShowTableTooltip(row) {
      return this.tableRowClassName({
        row: row
      }) === 'warning-row' || this.tableRowClassName({
        row: row
      }) === 'error-row' || this.tableRowClassName({
        row: row
      }) === 'used-row';
    }
  }, {
    key: "isShowReason",
    value: function isShowReason(row, reason) {
      return this.getInvalidOrderDetails(row)[reason];
    }
  }, {
    key: "isShowTitle",
    value: function isShowTitle(row) {
      return true;
    }
  }]);
  return MROrderTableComponent;
}((0, _vuePropertyDecorator.Mixins)(_loading.LoadingMixin, _milkRun.MilkRunMixin));

(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: String,
  default: '500px'
})], MROrderTableComponent.prototype, "tableHeight", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('$pageSize')], MROrderTableComponent.prototype, "onPageSizeChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('$unassignedOrders')], MROrderTableComponent.prototype, "onUnassignedOrdersChanges", null);
MROrderTableComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'MROrderTableComponent',
  components: {
    'order-table-column-selector': _orderTableColumnSelector.default,
    'fullscreen': _fullscreen.default,
    'el-table': _elementUi.Table,
    'el-table-column': _elementUi.TableColumn,
    'el-pagination': _elementUi.Pagination,
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-tooltip': _elementUi.Tooltip,
    'el-button': _elementUi.Button
  }
})], MROrderTableComponent);
var _default = MROrderTableComponent;
exports.default = _default;